export default "__VITE_ASSET__6f64dc7c__"